import 'thirdParty/highcharts/adapters/standalone-framework.src.js';
import 'thirdParty/highcharts/highcharts.src.js';
import 'thirdParty/highcharts/highcharts-more.src.js';
import 'thirdParty/highcharts/modules/annotations.src.js';
import 'thirdParty/highcharts/modules/data.src.js';
import 'thirdParty/highcharts/modules/drilldown.src.js';
import 'thirdParty/highcharts/modules/funnel.src.js';
import 'thirdParty/highcharts/modules/map.src.js';
import 'thirdParty/highcharts/modules/heatmap.src.js';
import 'thirdParty/highcharts/modules/no-data-to-display.src.js';
